import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-version-update-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './version-update-banner.component.html',
  styleUrls: ['./version-update-banner.component.scss'],
})
export class VersionUpdateBannerComponent {
  @Input() releaseMessage = '';
  @Output() update = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  onUpdate(): void {
    this.update.emit();
  }

  onDismiss(event: MouseEvent): void {
    event.stopPropagation();
    this.dismissed.emit();
  }
}
